export default "__VITE_ASSET__DnZoiBcQ__"